import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  isEveryOrdersBasketSelectableFormSelectedByProductVariation,
  isNoOrdersBasketSelectableFormSelectedByProductVariation,
} from 'state/orders-basket/selectors';
import { ordersBasketAllFormsSelectionToggledThunk } from 'state/orders-basket/thunks';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { getVisibleOrdersBasketProductDefinitionsByProductVariation } from 'state/workspaces/ordersBasket/productDefinitions/productDefinitions.selectors';
import { getNumberOfOrdersBasketFormsByProductVariation } from 'state/workspaces/ordersBasket/tabContent/tabContent.selectors';

import type {
  OrdersBasketHeaderDispatchProps,
  OrdersBasketHeaderOwnProps,
  OrdersBasketHeaderStateProps,
} from './OrdersBasketHeader.models';

export const mapStateToProps: MapStateToProps<OrdersBasketHeaderStateProps, OrdersBasketHeaderOwnProps, AppState> = (
  state: AppState,
  ownProps: OrdersBasketHeaderOwnProps,
) => {
  const productVariation = { productSubType: ownProps.productSubType, productType: ownProps.productType };
  const productDefinition = getVisibleOrdersBasketProductDefinitionsByProductVariation(state, productVariation);

  return {
    productDefinition: productDefinition !== undefined ? productDefinition[0] : undefined,
    isCheckboxDisabled: getNumberOfOrdersBasketFormsByProductVariation(state, productVariation) === 0,
    areAllFormsSelected: isEveryOrdersBasketSelectableFormSelectedByProductVariation(state, productVariation),
    isNoFormSelected: isNoOrdersBasketSelectableFormSelectedByProductVariation(state, productVariation),
  };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<
  OrdersBasketHeaderDispatchProps,
  OrdersBasketHeaderOwnProps
> = (dispatch: ThunkDispatch, ownProps: OrdersBasketHeaderOwnProps) => ({
  onCheckboxToggled() {
    dispatch(
      ordersBasketAllFormsSelectionToggledThunk({
        productSubType: ownProps.productSubType,
        productType: ownProps.productType,
      }),
    );
  },
});

export const connectOrdersBasketHeaderComponent = connect<
  OrdersBasketHeaderStateProps,
  OrdersBasketHeaderDispatchProps,
  OrdersBasketHeaderOwnProps,
  AppState
>(mapStateToProps, mapDispatchToProps);
